<script>
  import { onMount } from 'svelte'
  import Link from '/Atoms/Link'
  import { link } from 'svelte-navigator'

  export let text, href
  export const raw = null // remove from restProps
  
  let isLocal = false

  const isAnchor = href.indexOf("#") === 0

  const explicitlyLocalHosts = [
    'transmediale.de',
    'www.transmediale.de',
    'localhost'
  ]

  onMount(()=>{
    if (href && typeof(URL)==="function") {
      try {
        const url = new URL(href);
        let linkHostname = url.hostname || ""
        isLocal = explicitlyLocalHosts.includes(linkHostname) || window.location.hostname === linkHostname || isAnchor
      } catch (error) {
        isLocal = true
      }
    }
  })

  /*

  {#if isLocal}
    <Link to={href} {...$$restProps} target={isLocal ? null : "_blank"}>
      { text }
    </Link>
  {:else}
    <a class="link markdown" {...$$restProps} href={href} target={isLocal ? null : "_blank"}>
      { text }
    </a>
  {/if}

  <Link to={href} {...$$restProps} target={isLocal ? null : "_blank"}>
    { text }
  </Link>

  */

  function onClick(event) {
    if (isAnchor) {
      const anchor = href.substr(1)
      const targetElement = document.querySelector(`a[name="${anchor}"]`)
      // const almanacOverlay = document.querySelector(".almanac-overlay")
      // console.log(anchor, targetElement, almanacOverlay)
      if (targetElement) {
        targetElement.scrollIntoView({behavior: "smooth",})
      }
      event.preventDefault()
    }
  }
</script>

<a on:click={onClick} class="link markdown" {...$$restProps} href={href} target={isLocal ? null : "_blank"} use:link >
  { text }
  {#if !text}<slot />{/if}
</a>

<style lang="scss">
  .link.markdown {
    font-family: inherit;
    font-style: inherit;
    font-weight: inherit;
    text-decoration: underline;
    text-decoration-color: black;
    &:hover {
      text-decoration-color: black;
    }
    &[href^="#footnote"] {
      text-decoration: none;
    }
  }
</style>